/* wg-header-icons.js — one job only.

   The speech-bubble button is hardcoded in sections/header-nav-multi-site.liquid
   (~line 827) as <a href="#"> with title="Coming Soon". Ordering and hiding are
   handled in wg-header-icons.css; this only sets that one href, which CSS cannot.

   To remove this file entirely, edit that line in the theme code editor:
     <a href="#">   ->   <a href="/pages/contact" title="Contact support">
   then delete this asset and its <script> tag in layout/theme.liquid.
*/
(function () {
  function wire() {
    var btns = document.querySelectorAll('.modal-toggle.btn-example.wishlist');
    for (var i = 0; i < btns.length; i++) {
      var a = btns[i].querySelector('a');
      if (!a || a.getAttribute('href') === '/pages/contact') continue;
      a.setAttribute('href', '/pages/contact');
      a.setAttribute('title', 'Contact support');
      a.setAttribute('aria-label', 'Contact support');
      var t = btns[i].querySelector('svg title');
      if (t) t.textContent = 'Contact support';
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else { wire(); }
})();
